var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS3Logo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#8c3123}.st1{fill:#e05243}")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st0",
    d: "m78.27 88.79-34.08 17.12v299.48l34.08 16.97.28-.28V89.07l-.28-.28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st1",
    d: "M260.91 378.88 78.27 422.36V88.79l182.64 42.51v247.58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st0",
    d: "m178.57 310.85 77.43 9.82.42-1.13.56-126.94-.98-.99-77.43 9.68v109.56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st0",
    d: "m256 379.44 177.59 43.07.28-.43V89.07l-.28-.28L256 131.86v247.58"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st1",
    d: "M333.43 310.85 256 320.67V191.61l77.43 9.68v109.56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    style: {
      fill: "#5e1f18"
    },
    d: "M333.43 148.27 256 162.44l-77.43-14.17 77.29-20.2 77.57 20.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    style: {
      fill: "#f2b0a9"
    },
    d: "M333.43 363.73 256 349.42l-77.43 14.31 77.29 21.6 77.57-21.6"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st0",
    d: "M178.57 148.27 256 129.19l.56-.28V.56L256 0l-77.43 38.72v109.55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st1",
    d: "M333.43 148.27 256 129.19V0l77.43 38.72v109.55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st0",
    d: "m256 512-77.43-38.72V363.73L256 382.81l1.12 1.4-.28 125.55L256 512"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st1",
    d: "m256 512 77.43-38.72V363.73L256 382.81V512"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st1",
    d: "m433.59 88.79 34.22 17.12v299.48l-34.22 17.12V88.79"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3Logo);
export default __webpack_public_path__ + "static/media/S3Logo.b35abc9112d833c2b9f3d9c877c22f10.svg";
export { ForwardRef as ReactComponent };